import { AccountOnHoldCheckoutMessage } from "@/components/AccountOnHold";
import Box from "@/components/Box";
import { InternalTextLink } from "@/components/Links";
import Loading from "@/components/Loading";
import PartnerDashboardBox from "@/components/boxes/PartnerDashboardBox";
import { CMP_PERMISSION_STRIPE_ONBOARD } from "@/components/organisations/constants";
import { useOrganisationBasketContext } from "@/contexts/organisations/OrganisationBasketContext";
import { useOrganisationContext } from "@/contexts/organisations/OrganisationContext";
import Center from "@/tpo/Center";
import ChevronComponent from "@/tpo/Chevron";
import { Error } from "@/tpo/InputWrapper";
import Stack from "@/tpo/Stack";
import ButtonV2 from "@/v2/Buttons";

export default function PayOrderNowFields({ canSubmit, error, nonFieldError }) {
  const { organisation, permissions = [] } = useOrganisationContext();
  const { loading } = useOrganisationBasketContext();
  const canOnboardStripe = permissions.includes(CMP_PERMISSION_STRIPE_ONBOARD);

  if (organisation?.accountOnHold) {
    return <AccountOnHoldCheckoutMessage />;
  }

  return (
    <PartnerDashboardBox>
      <Stack gap={[24, 24, 28]}>
        <Box fontFamily="gilroyBold" fontSize={[28, 28, 36]}>
          Payment Details
        </Box>
        <Box fontFamily="gilroyMedium" fontSize={[14, 14, 16]}>
          {canOnboardStripe ? (
            <Box as="p" fontFamily="inherit" fontSize="inherit">
              It looks like you haven’t linked a Stripe account yet. You can still place orders, but payments will need to be made at the point of purchase. To earn commission, enable patient payments, or access invoiced billing, please <InternalTextLink href={`/cmp/organisations/${organisation.hashId}/dashboard/business`}>link your Stripe account.</InternalTextLink>
            </Box>
          ) : (
            <Box as="p" fontFamily="inherit" fontSize="inherit">
              Invoice payments are not available for your account. Please complete payment now to
              place your order.
            </Box>
          )}
        </Box>
      </Stack>
      <Center stacked gap={20}>
        <ButtonV2
          color="green"
          rightIcon={
            loading ? (
              <Loading
                minHeight={20}
                size={20}
                color="white"
                style={{
                  marginLeft: 10
                }}
              />
            ) : (
              <ChevronComponent />
            )
          }
          type="submit"
          disabled={!canSubmit || loading}
        >
          place order
        </ButtonV2>
        {(error || nonFieldError) && <Error error={error || nonFieldError} />}
      </Center>
    </PartnerDashboardBox>
  );
}
